import { useTranslation } from "next-i18next";
import Image from "next/image";
import { FC } from "react";
import { Container } from "~/components/Container";
import Trans from "~/types/translationKeys";
import styles from "./OurApproach.module.scss";

const OurApproach: FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.our_approach} id="our_approach">
      <div className={styles.pattern}>
        <Image
          src="/images/our_approach_pattern.png"
          alt="Our Approach Pattern"
          fill
        />
      </div>

      <Container>
        <div className={styles.container}>
          <Image
            src="/images/our_approach.png"
            alt="Our Approach"
            width={259}
            height={205}
          />

          <div className={styles.information}>
            <h3 className={styles.title}>{t(Trans.our_approach)}</h3>
            <p className={styles.content}>
              {t(
                Trans.at_cx_genie_ai_studio_we_believe_in_collaborative_partnerships_and_transparent_communication_throughout_the_whole_development_process
              )}
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default OurApproach;
